module.exports = __webpack_public_path__ + "img/sec3_slide2_mobile.dc4aadc5.jpg";